import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import cx from 'classnames';

class InputDateRangePicker extends Component {
  constructor(props) {
    super(props);
    const { value } = props.input;
    this.state = {
      focusedInput: null,
      startDate: value && value.startDate ? moment(value.startDate) : null,
      endDate: value && value.endDate ? moment(value.endDate) : null,
    };
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onDatesChange = this.onDatesChange.bind(this);
    this.setInitialVisibleMonth = this.setInitialVisibleMonth.bind(this);
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });
    this.props.input.onChange({
      startDate: startDate ? startDate.format('YYYY-MM-DD') : null,
      endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
    });
  }

  setInitialVisibleMonth() {
    const date = this.state[this.state.focusedInput];
    if (date) {
      return date;
    }
    return moment();
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const {
      input,
      meta: { touched, error },
      title,
      disabled,
      isFullWidth,
      ...rest
    } = this.props;

    const inputClasses = cx({
      'input-date-picker': true,
      'input-date-picker--no-title': !title,
      'input-date-picker--width-full': isFullWidth,
      'input-date-picker--state-error': touched && error,
      'input-date-picker--state-disabled': disabled,
      'input-date-picker--state-active': startDate || endDate,
    });

    return (
      <div className={inputClasses}>
        {title && <span className="input-date-picker__title">{title}</span>}
        <div className="input-date-picker__field">
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            focusedInput={focusedInput}
            onFocusChange={this.onFocusChange}
            onDatesChange={this.onDatesChange}
            initialVisibleMonth={this.setInitialVisibleMonth}
            hideKeyboardShortcutsPanel
            {...rest}
          />
        </div>
      </div>
    );
  }
}

InputDateRangePicker.propTypes = {
  input: PropTypes.object,
  range: PropTypes.object,
  meta: PropTypes.object,
  title: PropTypes.any,
  disabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
};

export default InputDateRangePicker;
